/** Formatting helpers (CLAUDE.md rule 15: workspace TZ default Asia/Manila, en-PH / fil-PH). */
export const WORKSPACE_TIME_ZONE = "Asia/Manila";
const UNITS = ["B", "KB", "MB", "GB"] as const;
const KILO = 1024;
const ONE_DECIMAL_BELOW = 100;

export function localeFor(language: string): string {
  return language === "fil" ? "fil-PH" : "en-PH";
}

export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined || bytes < 0) return "—";
  let value = bytes;
  let unit = 0;
  while (value >= KILO && unit < UNITS.length - 1) {
    value /= KILO;
    unit += 1;
  }
  const digits = unit === 0 || value >= ONE_DECIMAL_BELOW ? 0 : 1;
  return `${value.toFixed(digits)} ${UNITS[unit] ?? "B"}`;
}

export function formatDate(iso: string | null | undefined, language: string, withTime = false): string {
  if (!iso) return "—";
  const options: Intl.DateTimeFormatOptions = { month: "short", day: "numeric", year: "numeric", timeZone: WORKSPACE_TIME_ZONE };
  if (withTime) Object.assign(options, { hour: "numeric", minute: "2-digit" });
  return new Intl.DateTimeFormat(localeFor(language), options).format(new Date(iso));
}

const RELATIVE_STEPS: readonly (readonly [Intl.RelativeTimeFormatUnit, number])[] = [
  ["second", 60],
  ["minute", 60],
  ["hour", 24],
  ["day", 30],
  ["month", 12],
  ["year", Number.POSITIVE_INFINITY],
];

export function formatRelative(iso: string | null | undefined, language: string, now: number = Date.now()): string {
  if (!iso) return "—";
  let delta = (new Date(iso).getTime() - now) / 1000;
  const format = new Intl.RelativeTimeFormat(localeFor(language), { numeric: "auto" });
  for (const [unit, size] of RELATIVE_STEPS) {
    if (Math.abs(delta) < size) return format.format(Math.round(delta), unit);
    delta /= size;
  }
  return format.format(Math.round(delta), "year");
}

export function formatNumber(value: number, language: string): string {
  return new Intl.NumberFormat(localeFor(language)).format(value);
}
